/* tslint:disable */
/* eslint-disable */
/**
 * Melco APIService APIs
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ApiserviceMelcoModelsDesign,
    ApiserviceMelcoModelsDesignFromJSON,
    ApiserviceMelcoModelsDesignToJSON,
    ApiserviceMelcoModelsError,
    ApiserviceMelcoModelsErrorFromJSON,
    ApiserviceMelcoModelsErrorToJSON,
    ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem,
    ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSON,
    ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItemToJSON,
} from '../models';

export interface DesignEditorApiUserDesignsDesignEditorDeleteRequest {
    id: string;
    force?: boolean;
}

export interface DesignEditorApiUserDesignsDesignEditorDownloadByIdRequest {
    id: string;
}

export interface DesignEditorApiUserDesignsDesignEditorGetDefRequest {
    id: string;
}

export interface DesignEditorApiUserDesignsDesignEditorPreviewByIdRequest {
    id: string;
}

export interface DesignEditorApiUserDesignsDesignEditorSearchRequest {
    offset?: number;
    limit?: number;
    sortBy?: string;
    searchText?: string;
    service?: string;
}

export interface DesignEditorApiUserDesignsDesignEditorUpdateFileRequest {
    id: string;
    designFile?: Blob;
}

export interface DesignEditorApiUserDesignsDesignEditorUploadRequest {
    designFile?: Blob;
}

/**
 * 
 */
export class DesignEditorApi extends runtime.BaseAPI {

    /**
     */
    async userDesignsDesignEditorDeleteRaw(requestParameters: DesignEditorApiUserDesignsDesignEditorDeleteRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDesignEditorDelete.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.force !== undefined) {
            queryParameters['Force'] = requestParameters.force;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design-editor/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'DELETE',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignsDesignEditorDelete(requestParameters: DesignEditorApiUserDesignsDesignEditorDeleteRequest): Promise<void> {
        await this.userDesignsDesignEditorDeleteRaw(requestParameters);
    }

    /**
     */
    async userDesignsDesignEditorDownloadByIdRaw(requestParameters: DesignEditorApiUserDesignsDesignEditorDownloadByIdRequest): Promise<runtime.ApiResponse<Blob>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDesignEditorDownloadById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design-editor/{Id}/download`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.BlobApiResponse(response);
    }

    /**
     */
    async userDesignsDesignEditorDownloadById(requestParameters: DesignEditorApiUserDesignsDesignEditorDownloadByIdRequest): Promise<Blob> {
        const response = await this.userDesignsDesignEditorDownloadByIdRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDesignEditorGetDefRaw(requestParameters: DesignEditorApiUserDesignsDesignEditorGetDefRequest): Promise<runtime.ApiResponse<ApiserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDesignEditorGetDef.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design-editor/{Id}`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsDesignEditorGetDef(requestParameters: DesignEditorApiUserDesignsDesignEditorGetDefRequest): Promise<ApiserviceMelcoModelsDesign> {
        const response = await this.userDesignsDesignEditorGetDefRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDesignEditorPreviewByIdRaw(requestParameters: DesignEditorApiUserDesignsDesignEditorPreviewByIdRequest): Promise<runtime.ApiResponse<void>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDesignEditorPreviewById.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design-editor/{Id}/preview`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.VoidApiResponse(response);
    }

    /**
     */
    async userDesignsDesignEditorPreviewById(requestParameters: DesignEditorApiUserDesignsDesignEditorPreviewByIdRequest): Promise<void> {
        await this.userDesignsDesignEditorPreviewByIdRaw(requestParameters);
    }

    /**
     */
    async userDesignsDesignEditorSearchRaw(requestParameters: DesignEditorApiUserDesignsDesignEditorSearchRequest): Promise<runtime.ApiResponse<ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem>> {
        const queryParameters: runtime.HTTPQuery = {};

        if (requestParameters.offset !== undefined) {
            queryParameters['offset'] = requestParameters.offset;
        }

        if (requestParameters.limit !== undefined) {
            queryParameters['limit'] = requestParameters.limit;
        }

        if (requestParameters.sortBy !== undefined) {
            queryParameters['sort_by'] = requestParameters.sortBy;
        }

        if (requestParameters.searchText !== undefined) {
            queryParameters['search_text'] = requestParameters.searchText;
        }

        if (requestParameters.service !== undefined) {
            queryParameters['service'] = requestParameters.service;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        const response = await this.request({
            path: `/design-editor`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItemFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsDesignEditorSearch(requestParameters: DesignEditorApiUserDesignsDesignEditorSearchRequest): Promise<ApiserviceMelcoModelsGenericList1MelcoModelsDesignListItem> {
        const response = await this.userDesignsDesignEditorSearchRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDesignEditorUpdateFileRaw(requestParameters: DesignEditorApiUserDesignsDesignEditorUpdateFileRequest): Promise<runtime.ApiResponse<ApiserviceMelcoModelsDesign>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling userDesignsDesignEditorUpdateFile.');
        }

        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.designFile !== undefined) {
            formParams.append('design_file', requestParameters.designFile as any);
        }

        const response = await this.request({
            path: `/design-editor/{Id}/update`.replace(`{${"Id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsDesignEditorUpdateFile(requestParameters: DesignEditorApiUserDesignsDesignEditorUpdateFileRequest): Promise<ApiserviceMelcoModelsDesign> {
        const response = await this.userDesignsDesignEditorUpdateFileRaw(requestParameters);
        return await response.value();
    }

    /**
     */
    async userDesignsDesignEditorUploadRaw(requestParameters: DesignEditorApiUserDesignsDesignEditorUploadRequest): Promise<runtime.ApiResponse<ApiserviceMelcoModelsDesign>> {
        const queryParameters: runtime.HTTPQuery = {};

        const headerParameters: runtime.HTTPHeaders = {};

        const consumes: runtime.Consume[] = [
            { contentType: 'multipart/form-data' },
        ];
        // @ts-ignore: canConsumeForm may be unused
        const canConsumeForm = runtime.canConsumeForm(consumes);

        let formParams: { append(param: string, value: any): any };
        let useForm = false;
        // use FormData to transmit files using content-type "multipart/form-data"
        useForm = canConsumeForm;
        if (useForm) {
            formParams = new FormData();
        } else {
            formParams = new URLSearchParams();
        }

        if (requestParameters.designFile !== undefined) {
            formParams.append('design_file', requestParameters.designFile as any);
        }

        const response = await this.request({
            path: `/design-editor/upload`,
            method: 'POST',
            headers: headerParameters,
            query: queryParameters,
            body: formParams,
        });

        return new runtime.JSONApiResponse(response, (jsonValue) => ApiserviceMelcoModelsDesignFromJSON(jsonValue));
    }

    /**
     */
    async userDesignsDesignEditorUpload(requestParameters: DesignEditorApiUserDesignsDesignEditorUploadRequest): Promise<ApiserviceMelcoModelsDesign> {
        const response = await this.userDesignsDesignEditorUploadRaw(requestParameters);
        return await response.value();
    }

}
